// extracted by mini-css-extract-plugin
export var container = "AdminSelect_container__t0re1";
export var error = "AdminSelect_error__nNRNA";
export var errorMessage = "AdminSelect_errorMessage__YXLxy";
export var label = "AdminSelect_label__hSud5";
export var select = "AdminSelect_select__3r3Hy";